import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/mls/mls-logo.png")